import { USER_TYPE } from "../../../variables/config";

export const constrainst_table = {
    addbutton:{
        byuser:[
            USER_TYPE.REGISTRANT
        ]
    }
}
